// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___TYu-","right":"styles_right__12M0c"};